export const analytics = {
  closeIconClick: {
    eventName: 'sportTopFilter_search_back_icon_click',
  },
  open: {
    eventName: 'sportTopFilter_search_open',
  },
};
